import deskAttributesService from '@/api/deskattributes'
import { DESK_ATTRIBUTES } from '../types'

export default {
  namespaced: true,
  state: {
    attributes: [],
    deskAttributes: [],
    activeDeskAttributes: []
  },
  getters: {
    deskAttributes(state) {
      return state.deskAttributes
    },
    activeDeskAttributes(state) {
      return state.activeDeskAttributes
    },
  },
  mutations: {
    [DESK_ATTRIBUTES.SET_ATTRIBUTES] (state, deskAttributes){
      state.deskAttributes = deskAttributes
    },
    [DESK_ATTRIBUTES.SET_ACTIVE_ATTRIBUTES] (state, activeDeskAttributes){
      state.activeDeskAttributes = activeDeskAttributes
    },

  },
  actions: {
    getDeskAttributes: function ({commit, dispatch}) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        deskAttributesService.getDeskAttributes().then((response) => {
          commit(DESK_ATTRIBUTES.SET_ATTRIBUTES, response.data)
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getActiveDeskAttributes: function ({commit, dispatch}) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        deskAttributesService.getActiveDeskAttributes().then((response) => {
          commit(DESK_ATTRIBUTES.SET_ACTIVE_ATTRIBUTES, response.data)
          resolve()
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, {root: true})
        })
      })
    },
    async addDeskAttribute({dispatch}, deskAttribute) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        await deskAttributesService.addDeskAttribute(deskAttribute)
        await dispatch('getDeskAttributes')
      } catch (error) {
        return Promise.reject(error)
      } finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async updateDeskAttribute({dispatch}, deskAttribute) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        await deskAttributesService.updateDeskAttribute(deskAttribute)
        await dispatch('getDeskAttributes')
      } catch (error) {
        return Promise.reject(error)
      } finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    activateDeskAttribute: function (_, attributeId) {
      return new Promise((resolve, reject) => {
        deskAttributesService.activateDeskAttribute(attributeId).then(() => {
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    deactivateDeskAttribute: function (_, attributeId) {
      return new Promise((resolve, reject) => {
        deskAttributesService.deactivateDeskAttribute(attributeId).then(() => {
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    setDeskAttributes({commit}, deskAttributes) {
      commit(DESK_ATTRIBUTES.SET_ATTRIBUTES, deskAttributes)
    }
  }
}
